import React, { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import ViewStudent from "./AdminViewReward";
import "./AdReward.scss";

import { Delete } from "@mui/icons-material";
// import TechAddLesson from "./AdminAddReward";
// import TechUpdateLesson from "./AdminUpdateReward";
import AdNavbar from "../AdNavbar/AdNavbar";
import Pagination from "@mui/material/Pagination"; // Import Pagination
import Stack from "@mui/material/Stack"; // Impo

export default function AdReward() {
  const useAuth = window.localStorage;
  const Token = useAuth.getItem("accessToken");
  const [awards, setAwards] = useState();
  const [change, setChange] = useState(false);
  const [page, setPage] = useState(1); // Current page state
  const [totalPages, setTotalPages] = useState(1); // Total pages state
  const [limit] = useState(10); // Number of items per page

  const config = {
    headers: {
      Authorization: Token,
    },
  };

  useEffect(() => {
    axios
      .get(`awards?page=${page}&limit=${limit}`, config)
      .then((response) => {
        console.log(response.data);
        setAwards(response.data.awards);
        setTotalPages(response.data.count < limit ? 1 : Math.ceil(response.data.count / limit)); // Assuming your API returns the total number of pages
      })
      .catch((err) => {
        console.log(err);
      });
  }, [page]);

  const deleteLesson = (id) => {
    const formData = { award_id: id };
    if (window.confirm("Mukofotni o'chirmoqchimisiz?")) {
      axios
        .put("/award", formData, config)
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const toggleAction = (e) => {
    const actionBody = e.target.nextSibling;
    console.log(actionBody, "actionBody");
    if (actionBody.style.display === "block") {
      actionBody.style.display = "none";
    } else {
      actionBody.style.display = "block";
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value); // Update the page state when user changes the page
  };

  return (
    <>
      <AdNavbar />
      <main className="mainPage">
        {/* {awards === undefined ? (
          <section className="mygroup-section tech-lesson-section">

          </section>
        ) : ( */}
          <section className="mygroup-section tech-lesson-section ad-teacher">
            <div className="container">
              <div className="mygroup">
                <table className="mygroup__table desktop">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Talabalar</th>
                      <th>Foiz</th>
                      <th>Holati</th>
                      <th className="add-wrapper">
                        {/* <TechAddLesson /> */}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {awards &&
                      awards.map((item, index) => (
                        <tr key={index} id={item.id}>
                          <td>{index + 1}</td>
                          <td id="lessonName">
                            <p onClick={() => setChange(!change)}>
                              {item.student_name ? item.student_name : "Null"}
                            </p>
                          </td>
                          <td>
                            <p>{item.award_percent}%</p>
                          </td>
                          <td>
                            <p>{item.is_active ? "Faol" : "Nofaol"}</p>
                          </td>
                          <td className="add-wrapper">
                            <ViewStudent data={item} />
                            <button
                              className="btn-delete"
                              onClick={() => deleteLesson(item.id)}
                              style={{ color: "crimson" }}
                            >
                              <Delete />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <div className="mygroup__table mobile">
                  <div className="mygroup__table-head">
                    <div className="">#</div>
                    <div className="">Talabalar</div>
                    <div></div>
                  </div>
                  <div className="mygroup__table-body">
                    {awards &&
                      awards.map((item, index) => (
                        <div key={index} className="mygroup__table-body--item">
                          <div className=""><p>{index + 1}</p></div>
                          <div className="group-name">
                          <p onClick={() => setChange(!change)}>
                              {item.student_name ? item.student_name : "Null"}
                            </p>
                          </div>
                          <div>
                          <button className="btn-action"
                                onClick={ toggleAction}>
                                  •••
                              </button>
                              <div className="ad-teacher-action-body">
                                <ViewStudent data={item} />
                                <button
                                  className="btn-delete"
                                  onClick={() => deleteLesson(item.id)}
                                  style={{ color: "crimson" }}
                                >
                                  <Delete />
                                </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <Stack spacing={2} alignItems="center" marginTop="20px">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="secondary"
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              </div>
            </div>
          </section>
        {/* )} */}
      </main>
    </>
  );
}
